import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { FILTER_NAMES } from "../constants/filters";
import { cssMainSelector } from "../lib/cssSelectors";
import MediaContainer from "./MediaContainer";
import DataCreditsFilterContainer from "../containers/filters/DataCreditsFilterContainer";
import PriceFilterContainer from "../containers/filters/PriceFilterContainer";
import VoiceCreditsFilterContainer from "../containers/filters/VoiceCreditsFilterContainer";
import { CSS_CLASS_PREFIX } from "../constants/css";
import MaterialIcon from "./MaterialIcon";
import { withTranslation } from "react-i18next";
import { MODALS } from "../constants/modals";
import MonthlyFeeFilterContainer from "../containers/filters/MonthlyFeeFilterContainer";

const containerPadding = css `padding: ${p => p.theme.spacing.sm} ${p => p.theme.spacing.sm}`;
const Container = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.filter.mainFiltersBackgroundColor};
    border-color: ${p => p.theme.filter.mainFiltersBorderColor};
    border-radius: ${p => p.theme.generic.borderRadius};
    border-style: solid;
    border-width: 1px;
    ${containerPadding};
    width: 100%;
  }
`;

const Filters = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    justify-content: space-between;
  }

  ${p => cssMainSelector(p.theme.tdsId, { mediaSizeName: "mdphone-down" })} {
    .${CSS_CLASS_PREFIX}-filter-2 {
      display: none;
    }
  }
`;

const filterPadding = css `padding: ${p => p.theme.spacing.md} ${p => p.theme.spacing.lg}`;
const Filter = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    ${filterPadding};
    width: 50%;
    
    &.${CSS_CLASS_PREFIX}-single-filter {
      width: 100%;
    }
  }
  
  ${p => cssMainSelector(p.theme.tdsId, { mediaSizeName: "mdphone-down" })} {
    width: 100%;
  }
`;

const MoreFilters = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    color: ${p => p.theme.filter.moreFiltersColor};
    cursor: pointer;
    font-size: ${p => p.theme.font.sizeSm};
    text-align: center;
    user-select: none;

    * {
      color: ${p => p.theme.filter.moreFiltersColor};
      cursor: pointer;
      font-size: ${p => p.theme.font.sizeSm};
    }
  }
`;

class MobileFilterPanel extends PureComponent {
  render() {
    const { t, updateModal } = this.props;

    return (
      <Container>
        <MediaContainer>
          <Filters>{this.filtersList()}</Filters>
          {updateModal != null && (
            <MoreFilters
              onClick={updateModal.bind(
                this,
                { noData: "required" },
                MODALS.filterModal
              )}
            >
              <MaterialIcon>filter_list</MaterialIcon> {t("moreFilters")}
            </MoreFilters>
          )}
        </MediaContainer>
      </Container>
    );
  }

  filtersList() {
    const { clientConfig, offerType } = this.props;

    const filters = clientConfig.widgetOptions[offerType].filters.mobileFilters;
    const items = [];
    let i = 1;

    let extraClassName = "";
    if (filters.length === 1) {
      extraClassName = `${CSS_CLASS_PREFIX}-single-filter`;
    }

    for (const filter of filters) {
      if (i <= 2) {
        const className = `${CSS_CLASS_PREFIX}-filter-${i} ${extraClassName}`;
        if (filter === FILTER_NAMES.dataCredits) {
          items.push(
            <Filter key={FILTER_NAMES.dataCredits} className={`${className}`}>
              <DataCreditsFilterContainer
                labelPosition={"side"}
                labelShort
                showShort
              />
            </Filter>
          );
        } else if (filter === FILTER_NAMES.monthlyFee) {
          items.push(
            <Filter key={FILTER_NAMES.price} className={`${className}`}>
              <MonthlyFeeFilterContainer labelPosition="side" labelShort />
            </Filter>
          );
        } else if (filter === FILTER_NAMES.price) {
          items.push(
            <Filter key={FILTER_NAMES.price} className={`${className}`}>
              <PriceFilterContainer labelPosition="side" labelShort />
            </Filter>
          );
        } else if (filter === FILTER_NAMES.voiceCredits) {
          items.push(
            <Filter key={FILTER_NAMES.voiceCredits} className={`${className}`}>
              <VoiceCreditsFilterContainer
                labelPosition="side"
                labelShort
                showShort
              />
            </Filter>
          );
        }
        i += 1;
      }
    }

    return items;
  }
}

MobileFilterPanel.propTypes = {
  clientConfig: PropTypes.object.isRequired,
  offerType: PropTypes.string.isRequired,
  updateModal: PropTypes.func
};

export default withTranslation(["filters"])(MobileFilterPanel);
